import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "ghost" | "danger";
type Size = "sm" | "md" | "lg";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
  /** An icon in front of the label, as the design system pairs them. */
  icon?: ReactNode;
  children?: ReactNode;
}

/**
 * The design system's button.
 *
 * It used to compute hover and press in React state, re-rendering on every mouse move;
 * here they are plain CSS states (`ui.css`), which also covers keyboard focus.
 */
export function Button({
  variant = "primary",
  size = "md",
  fullWidth = false,
  icon,
  type = "button",
  className,
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`ui-button ui-button-${variant} ui-button-${size}${fullWidth ? " ui-button-full" : ""}${className ? ` ${className}` : ""}`}
      {...rest}
    >
      {icon ? (
        <span className="ui-button-content">
          {icon}
          {children}
        </span>
      ) : (
        <span>{children}</span>
      )}
    </button>
  );
}
